import { constant } from 'lodash-es';
import {
  LEASE_DEALS_BEST_BODY_TYPE_PATH,
  LEASE_DEALS_BEST_ENGINE_TYPE_PATH,
  LEASE_DEALS_BEST_TYPE_PATH,
  LEASE_DEALS_MONTHLY_199_PATH,
  LEASE_DEALS_MAKE_PATH,
  LEASE_DEALS_MAKE_CITY_STATE_PATH,
} from 'site-modules/shared/constants/lease-deals/routes';
import { FILTER_QUERY_PARAMS } from 'site-modules/shared/constants/lease-deals/lease-deals';

const makeSlugsResolver = (urlContext, params) => ({
  [FILTER_QUERY_PARAMS.MAKE]: { [params[FILTER_QUERY_PARAMS.MAKE]]: urlContext?.vehicle?.make?.name },
});

const pageSlugsMapsResolvers = {
  [LEASE_DEALS_BEST_BODY_TYPE_PATH]: constant({
    [FILTER_QUERY_PARAMS.BODY_TYPE]: {
      suv: 'SUV',
      sedan: 'Sedan',
      'cargo-van': 'Full Size Van',
      convertible: 'Convertible',
      coupe: 'Coupe',
      crossover: 'SUV',
      hatchback: 'Hatchback',
      minivan: 'Minivan',
      truck: 'Pickup',
      wagon: 'Station Wagon',
    },
  }),
  [LEASE_DEALS_BEST_ENGINE_TYPE_PATH]: constant({
    [FILTER_QUERY_PARAMS.ENGINE_TYPE]: {
      diesel: 'diesel',
      electric: 'electric',
      hybrid: 'hybrid',
    },
  }),
  [LEASE_DEALS_BEST_TYPE_PATH]: constant({
    [FILTER_QUERY_PARAMS.EDMUNDS_TYPE_CATEGORIES]: {
      luxury: 'Luxury',
    },
  }),
  [LEASE_DEALS_MONTHLY_199_PATH]: constant({
    [FILTER_QUERY_PARAMS.MONTHLY_PAYMENT]: {
      199: '*-299',
    },
  }),
  [LEASE_DEALS_MAKE_PATH]: makeSlugsResolver,
  [LEASE_DEALS_MAKE_CITY_STATE_PATH]: makeSlugsResolver,
};

export const buildPageSlugToValueMap = ({ routePath, urlContext, params = {} }) => {
  const pageMapResolver = pageSlugsMapsResolvers[routePath] || constant({});
  return pageMapResolver(urlContext, params);
};
